export const CATEGORY_STATUS_EXCLUDED = -1
export const CATEGORY_STATUS_DISABLED = 0
export const CATEGORY_STATUS_ENABLED = 1

export const CATEGORY_STATUS_LABELS = [
  {
    label: 'Включён',
    value: CATEGORY_STATUS_ENABLED
  },
  {
    label: 'Отключён',
    value: CATEGORY_STATUS_DISABLED
  },
  {
    label: 'Недоступен',
    value: CATEGORY_STATUS_EXCLUDED
  }
]

/*
  Api file field name for uploading stuff
*/

export const UPLOAD_NAME_CATEGORY_ICON = 'category-icon'
export const UPLOAD_NAME_CATEGORY_ALT_ICON = 'alt-category-icon'
